import { EventBusy } from '@mui/icons-material';
import { Chip } from '@mui/material';

export const MoreTimeRequestedBadge: React.FC = () => (
  <Chip
    icon={<EventBusy fontSize="small" />}
    label="More time requested"
    size="small"
    color="error"
  />
);
